import { useState } from 'react';
import { Icon } from '@/components/ui/Icon';
import styles from '../AuthModal/AuthModal.module.css';

const PasswordInput = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = "password",
  id,
  name,
  autoComplete = "current-password",
  className = "",
  hasError = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const inputClass = `${styles.formInput} ${hasError ? styles.invalid : ''} ${className}`.trim();

  return (
    <div className={styles.passwordInputContainer}>
      <input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        id={id}
        name={name}
        className={inputClass}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        {...props}
      />
      <button
        type="button"
        className={styles.passwordToggle}
        onClick={togglePasswordVisibility}
        aria-label={showPassword ? "Hide password" : "Show password"}
        tabIndex={-1} // Prevent tab focus, users can use input field
      >
        {showPassword ? <Icon name="EyeOff" size={20} /> : <Icon name="Eye" size={20} />}
      </button>
    </div>
  );
};

export default PasswordInput;
